var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "Profile__General__Page" },
    [
      _c("div", { staticClass: "Profile__General__Page__Header" }, [
        _c("h1", [_vm._v("הגדרות לקורס " + _vm._s(_vm.course.name))]),
        _c(
          "div",
          { staticClass: "loading" },
          [
            _c("b-loading", {
              attrs: { "is-full-page": true, "can-cancel": false },
              model: {
                value: _vm.isLoading,
                callback: function ($$v) {
                  _vm.isLoading = $$v
                },
                expression: "isLoading",
              },
            }),
          ],
          1
        ),
      ]),
      _c(
        "b-field",
        {
          staticStyle: { "margin-top": "10px" },
          attrs: { label: "סוג קורס", message: _vm.courseTypeMessage },
        },
        [
          _c(
            "b-select",
            {
              attrs: {
                loading: _vm.courseTypesLoading,
                placeholder: "— בחר סוג קורס —",
                expanded: "",
              },
              model: {
                value: _vm.model.courseTypeId,
                callback: function ($$v) {
                  _vm.$set(_vm.model, "courseTypeId", $$v)
                },
                expression: "model.courseTypeId",
              },
            },
            [
              _c(
                "option",
                { attrs: { disabled: "" }, domProps: { value: null } },
                [_vm._v("— בחר סוג קורס —")]
              ),
              _vm._l(_vm.courseTypes, function (courseType) {
                return _c(
                  "option",
                  { key: courseType.id, domProps: { value: courseType.id } },
                  [_vm._v(" " + _vm._s(courseType.name) + " ")]
                )
              }),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "b-field",
        {
          staticStyle: { "margin-top": "10px" },
          attrs: { label: "הקורס הקודם", message: _vm.previousCourseMessage },
        },
        [
          _c("v-select", {
            staticStyle: { "min-width": "300px" },
            attrs: {
              dir: "rtl",
              loading: _vm.previousCoursesLoading,
              filterable: true,
              clearable: true,
              searchable: true,
              "close-on-select": true,
              reduce: (item) => item.id,
              getOptionLabel: (item) => `${item.id} - ${item.name}`,
              options: _vm.previousCourseOptions,
              placeholder: "— ללא קורס קודם —",
            },
            model: {
              value: _vm.model.previousCourseId,
              callback: function ($$v) {
                _vm.$set(_vm.model, "previousCourseId", $$v)
              },
              expression: "model.previousCourseId",
            },
          }),
        ],
        1
      ),
      _c(
        "b-field",
        {
          staticStyle: { "margin-top": "10px" },
          attrs: { label: "סטטוס קורס" },
        },
        [
          _c(
            "b-checkbox",
            {
              staticClass: "checkbox",
              attrs: { label: "", type: "is-link is-light" },
              model: {
                value: _vm.model.status,
                callback: function ($$v) {
                  _vm.$set(_vm.model, "status", $$v)
                },
                expression: "model.status",
              },
            },
            [_vm._v(" " + _vm._s(_vm.model.status ? " ON" : "OFF") + " ")]
          ),
        ],
        1
      ),
      _c(
        "b-field",
        {
          staticStyle: { "margin-top": "10px" },
          attrs: { label: "הראה דף בית חדש" },
        },
        [
          _c(
            "b-checkbox",
            {
              staticClass: "checkbox",
              attrs: { label: "", type: "is-link is-light" },
              model: {
                value: _vm.model.showNewHomePage,
                callback: function ($$v) {
                  _vm.$set(_vm.model, "showNewHomePage", $$v)
                },
                expression: "model.showNewHomePage",
              },
            },
            [
              _vm._v(
                " " + _vm._s(_vm.model.showNewHomePage ? " ON" : "OFF") + " "
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "b-field",
        {
          staticStyle: { "margin-top": "10px" },
          attrs: { label: "הראה תכנית דינמית" },
        },
        [
          _c(
            "b-checkbox",
            {
              staticClass: "checkbox",
              attrs: { label: "", type: "is-link is-light" },
              model: {
                value: _vm.model.showDynamicProgram,
                callback: function ($$v) {
                  _vm.$set(_vm.model, "showDynamicProgram", $$v)
                },
                expression: "model.showDynamicProgram",
              },
            },
            [
              _vm._v(
                " " + _vm._s(_vm.model.showDynamicProgram ? " ON" : "OFF") + " "
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "Profile__General__Page__Form" },
        [
          _c("b-field", { attrs: { label: "על הקורס" } }, [
            _c(
              "div",
              { staticClass: "item" },
              [
                _vm.ready
                  ? _c("NewActivityEditor", {
                      ref: "description",
                      attrs: {
                        ckEditorContent: _vm.model.description,
                        content: _vm.model.description,
                      },
                      on: { onEditorChange: _vm.setDescription },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _c("b-field", { attrs: { label: "סילבוס" } }, [
            _c(
              "div",
              { staticClass: "item" },
              [
                _vm.ready
                  ? _c("NewActivityEditor", {
                      ref: "syllabus",
                      attrs: {
                        ckEditorContent: _vm.model.syllabus,
                        content: _vm.model.syllabus,
                      },
                      on: { onEditorChange: _vm.setSyllabus },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _c(
            "b-field",
            {
              scopedSlots: _vm._u([
                {
                  key: "label",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        { staticClass: "field-label-with-history" },
                        [
                          _c("span", [_vm._v("פתיח")]),
                          _c(
                            "b-button",
                            {
                              attrs: {
                                size: "is-small",
                                type: "is-text",
                                title: "היסטוריית שינויים",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.showHistory(
                                    "openingRemarks",
                                    "פתיח"
                                  )
                                },
                              },
                            },
                            [
                              _c("b-icon", {
                                attrs: { icon: "history", size: "is-small" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c(
                "div",
                { staticClass: "item" },
                [
                  _vm.ready
                    ? _c("NewActivityEditor", {
                        ref: "openingRemarks",
                        attrs: {
                          ckEditorContent: _vm.model.openingRemarks,
                          content: _vm.model.openingRemarks,
                        },
                        on: { onEditorChange: _vm.setOpeningRemarks },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]
          ),
          _c("b-field", { attrs: { label: "קבצים" } }, [
            _c(
              "div",
              { staticClass: "item" },
              [
                _vm.ready
                  ? _c("NewActivityEditor", {
                      ref: "courseFilesContent",
                      attrs: {
                        ckEditorContent: _vm.model.courseFilesContent,
                        content: _vm.model.courseFilesContent,
                      },
                      on: { onEditorChange: _vm.setFiles },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _c("b-field", { attrs: { label: "תנאי שימוש" } }, [
            _c(
              "div",
              { staticClass: "item" },
              [
                _vm.ready
                  ? _c("NewActivityEditor", {
                      ref: "termsOfUse",
                      attrs: {
                        ckEditorContent: _vm.model.termsOfUse,
                        content: _vm.model.termsOfUse,
                      },
                      on: { onEditorChange: _vm.setTerms },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _c(
            "b-field",
            { attrs: { label: "ניהול משפטי מוטיבציה" } },
            [
              _c(
                "b-checkbox",
                {
                  model: {
                    value: _vm.model.showMotivationText,
                    callback: function ($$v) {
                      _vm.$set(_vm.model, "showMotivationText", $$v)
                    },
                    expression: "model.showMotivationText",
                  },
                },
                [_vm._v(" הצגת משפטי מוטיבציה בעמוד הבית של הקורס ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-button",
        {
          staticClass: "save-btn",
          attrs: { type: "is-info" },
          on: { click: _vm.updateCourse },
        },
        [_vm._v(" שמור ")]
      ),
      _c(
        "b-modal",
        {
          attrs: { width: 800, scroll: "keep" },
          model: {
            value: _vm.isHistoryModalActive,
            callback: function ($$v) {
              _vm.isHistoryModalActive = $$v
            },
            expression: "isHistoryModalActive",
          },
        },
        [
          _c("DialogContentHistory", {
            attrs: {
              isActive: _vm.isHistoryModalActive,
              courseId: _vm.course.id,
              fieldName: _vm.currentHistoryField,
              fieldLabel: _vm.currentHistoryLabel,
            },
            on: { close: _vm.closeHistoryModal, restore: _vm.restoreContent },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }